import { render, staticRenderFns } from "./X-Mark.vue?vue&type=template&id=869eaa32&scoped=true&"
var script = {}
import style0 from "./X-Mark.vue?vue&type=style&index=0&id=869eaa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869eaa32",
  null
  
)

export default component.exports